import { render, staticRenderFns } from "./display-field-date.vue?vue&type=template&id=5305dc8e&scoped=true&"
import script from "./display-field-date.ts?vue&type=script&lang=ts&"
export * from "./display-field-date.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-date.scss?vue&type=style&index=0&id=5305dc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305dc8e",
  null
  
)

export default component.exports